export default __webpack_public_path__ + "static/media/companies-experts-support.48eabab1.svg";